function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.812 11.366a4.73 4.73 0 00-6.887-6.48L6.58 19.23a3.665 3.665 0 00-.98 1.767l-1.587 6.875a.512.512 0 00.614.613l6.875-1.586a3.664 3.664 0 001.767-.98l14.345-14.345c.069-.068.135-.138.198-.21zM26.36 9.913a2.683 2.683 0 00-3.773-3.773l3.773 3.773zm-5.232-2.336l3.795 3.795-12.378 12.377-3.794-3.794L21.128 7.577zM7.551 21.649l-.99 4.29 4.29-.99-3.3-3.3z",
  fill: "currentColor"
})));